import { BigNumber } from '@ethersproject/bignumber';
import { BIG_ZERO } from 'app/constants';
import { getEffectiveCollateral, SiloAsset } from 'app/queries/decoratedSilo';

type GetRemainingAmount = (params: {
  normalizedLendingAmount: BigNumber | null;
  normalizedProtectedAmount: BigNumber | null;
  isFullLendingAmount: boolean;
  isFullProtectedAmount: boolean;
  selectedAsset: SiloAsset;
}) => BigNumber | null;

export const getRemainingAmount: GetRemainingAmount = ({
  normalizedLendingAmount,
  normalizedProtectedAmount,
  isFullLendingAmount,
  isFullProtectedAmount,
  selectedAsset,
}) => {
  if (!normalizedLendingAmount && !normalizedProtectedAmount) return null;

  const { collateralBalance: lendingBalance, collateralOnlyBalance: protectedBalance } = selectedAsset;

  const lendingToWithdraw = getAmountToWithdraw(normalizedLendingAmount, isFullLendingAmount, lendingBalance);
  const protectedToWithdraw = getAmountToWithdraw(normalizedProtectedAmount, isFullProtectedAmount, protectedBalance);

  const totalBalance = getEffectiveCollateral(selectedAsset);
  const totalToWithdraw = lendingToWithdraw.add(protectedToWithdraw);
  const remaining = totalBalance.sub(totalToWithdraw);

  return remaining.gt(BIG_ZERO) ? remaining : null;
};

type GetAmountToWithdraw = (normalizedAmount: BigNumber | null, isFullAmount: boolean, balance: BigNumber) => BigNumber;

const getAmountToWithdraw: GetAmountToWithdraw = (normalizedAmount, isFullAmount, balance) => {
  if (!normalizedAmount) return BIG_ZERO;

  return isFullAmount ? balance : normalizedAmount;
};
